import { gql } from "@apollo/client";

export const GET_ACADEMIC_YEAR = gql`
  query GetAcademicYear($keyword: String) {
    getAcademicYear(keyword: $keyword) {
      _id
      academic_year
    }
  }
`;

export const GET_SCHOOL = gql`
  query GetSchoolData($keyword: String) {
    getSchoolData(keyword: $keyword) {
      _id
      school_name
      school_name_en
    }
  }
`;

export const GET_GROUP = gql`
  query GetGroup($keyword: String) {
    getGroup(keyword: $keyword) {
      _id
      group_name
    }
  }
`;

export const GET_LEVEL = gql`
  query GetLevel($keyword: String) {
    getLevel(keyword: $keyword) {
      _id
      level_name
    }
  }
`;

export const GET_USER_PAGINATION = gql`
  query GetUserPagination(
    $keyword: String
    $page: Int
    $limit: Int
    $pagination: Boolean
    $role: UserRole
  ) {
    getUserPagination(
      keyword: $keyword
      page: $page
      limit: $limit
      pagination: $pagination
      role: $role
    ) {
      data {
        _id
        last_name
        first_name
        latin_name
        role
        gender
        phone_number
        email
        is_enabled
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const GET_CLASS_BY_ACADEMICYEAT_AND_SCHOOL = gql`
  query GetClassByAcademicYearAndSchool($academicYearId: ID, $schoolId: ID) {
    getClassByAcademicYearAndSchool(
      academic_year_id: $academicYearId
      school_id: $schoolId
    ) {
      _id
      academic_year_id {
        _id
        academic_year
        remark
      }
      group_id {
        _id
        group_name
        remark
      }
      level_id {
        _id
        level_name
        remark
      }
      teacher_id {
        _id
        first_name
        last_name
        latin_name
      }
      school_id {
        _id
        school_name
        school_name_en
        remark
      }
    }
  }
`;

export const GET_TEACHER_USER_BY_ACADEMIC_YEAR = gql`
query GetTeacherUserByAcademicYear($academicYearId: ID!, $schoolId: ID) {
  getTeacherUserByAcademicYear(academic_year_id: $academicYearId, school_id: $schoolId) {
    _id
    first_name
    latin_name
    last_name
  }
}`
